#import "../fragments/chat-settings-fragment.graphql"

mutation GenerateRecommendations($input: RecommendationsGenerateInput!) {
    recommendationsGenerate(input: $input) {
        chatSettings {
            ...ChatSettingsFragment
        }
    }
}
